import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  padding: ', 'px 0 ', 'px 0;\n  border-top: ', ';\n'], ['\n  padding: ', 'px 0 ', 'px 0;\n  border-top: ', ';\n']);

import styled from 'styled-components';
import { colors, gridSize } from '@atlaskit/theme';

var FooterDiv = styled.div(_templateObject, gridSize(), gridSize() / 2, function (_ref) {
  var shouldHideSeparator = _ref.shouldHideSeparator;
  return shouldHideSeparator ? '0' : '2px solid ' + colors.N40A;
});

export default FooterDiv;